module.exports = __webpack_public_path__ + "img/56.74beb1fc.jpg";